import { useSelector } from 'react-redux';
import { globalInterestRate as globalInterestRateSelector } from '~/App/shared/selectors/finance';
import {
  MONTHLY_COST_RESIDUAL_VALUE_PERCENTAGE,
  MONTHLY_COST_DOWNPAYMENT_PERCENT,
  MONTHLY_COST_MONTHS
} from '~/config/constants';
import { calculateFinance } from '~/helpers/calculator';

export interface FinanceMonthlyCostProps {
  price: number;
  months?: number;
  withResidualValue?: boolean;
  children: ({ value }: { value: number }) => JSX.Element;
}
const FinanceMonthlyCost = ({
  price,
  children,
  withResidualValue,
  months = MONTHLY_COST_MONTHS
}: FinanceMonthlyCostProps) => {
  const interestRate = useSelector(globalInterestRateSelector);
  const downPayment = price * MONTHLY_COST_DOWNPAYMENT_PERCENT;

  const value = price
    ? calculateFinance({
        price,
        downPayment,
        months,
        interestRate,
        residualPercentage: withResidualValue
          ? MONTHLY_COST_RESIDUAL_VALUE_PERCENTAGE
          : 0
      })
    : 0;

  return children({ value });
};

export default FinanceMonthlyCost;
